import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PENDING_CHANGES_AUTHORS_SELECTION_ACTION_TYPE } from '../actions/pendingChangesAuthorsSelection.actions';

const initialState = {
  activeApplicationId: null,
  authorKeysByApplicationId: {},
  aiRunsByExecutionId: {},
};

const pendingChangesAuthorsSelectionReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case PENDING_CHANGES_AUTHORS_SELECTION_ACTION_TYPE.OPEN_SELECTION: {
        const { applicationId, defaultAuthorKeys } = payload;

        draft.activeApplicationId = applicationId;
        draft.authorKeysByApplicationId[applicationId] =
          state.authorKeysByApplicationId[applicationId] ?? defaultAuthorKeys;
        break;
      }

      case PENDING_CHANGES_AUTHORS_SELECTION_ACTION_TYPE.CLOSE_SELECTION:
        delete draft.authorKeysByApplicationId[payload.applicationId];

        if (state.activeApplicationId === payload.applicationId) {
          draft.activeApplicationId = null;
        }

        break;

      case PENDING_CHANGES_AUTHORS_SELECTION_ACTION_TYPE.SET_SELECTION:
        draft.authorKeysByApplicationId[payload.applicationId] = payload.authorKeys;
        break;

      case PENDING_CHANGES_AUTHORS_SELECTION_ACTION_TYPE.SET_AI_RUNS:
        Object.assign(draft.aiRunsByExecutionId, payload);
        break;

      // The loan page resets the store as it mounts, after its layout effect opened the selection: the open
      // selection outlives the reset, and only closing the loan page ends it.
      case RESET_STATE:
        return {
          ...initialState,
          activeApplicationId: state.activeApplicationId,
          authorKeysByApplicationId: state.authorKeysByApplicationId,
        };

      default:
        break;
    }
  });

export default pendingChangesAuthorsSelectionReducer;
